<sub-layout [showFooter]="showFooter" [sidebarCollapsed]="sidebarCollapsed" [sidebarWidth]="sidebarWidth">
  <sub-mobile-nav
    mobile-nav
    #mobileNav
    [navItems]="navItems"
    [showHub]="true"
    (hubLaunch)="launchHub()"
  ></sub-mobile-nav>

  <sub-header
    header
    [logoLink]="logoLink"
    (openMenu)="mobileNav.toggleSideNav()"
    [menuItems]="headerMenuItems"
    [user]="user"
  ></sub-header>

  <sub-side-nav
    side-nav
    [navItems]="navItems"
    [isCollapsed]="sidebarCollapsed"
    (collapsed)="onSidebarToggle($event)"
    (hubLaunch)="launchHub()"
  ></sub-side-nav>

  <sub-footer footer></sub-footer>

  <sub-mobile-footer [navItems]="mobileNavItems"></sub-mobile-footer>
</sub-layout>
